import React, { Component } from 'react';
import { connect } from 'react-redux';
import { siteSettingsState, popupDispatcher, currentPageState, combineStates, identityState } from '../../../store';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { configuratorActions, flagActions, importActions, superCodeActions, translate } from '../../../services';
import { BusyContainer, TermsOfUseWindow } from '../../../components';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { GlobalIconNew, SettingsIconNew, closePopup } from '../../../../style/images';
import { RequestSupport } from './RequestSupport';
import { UserMenu } from './UserMenu';
import { Link } from 'react-router-dom';

export class SiteFooterComponent extends Component {

  constructor(props){
    super(props);
    this.state = {
      showTC : false,
      userMenuActive: false,
    }
  }
  hidePopup = () => {
    this.props.hidePopup();
  }
  openTermsOfUse = () => {
    // this.props.setPopup( { title: translate( 'Terms of Use' ), component: <TermsOfUseWindow hidePopup= { this.hidePopup } />, showHeader: false, keepOpen: false } );
    this.setState({showTC:true})
  }

  closeTermsOfUse = ()=>{
    this.setState({showTC:false})
  }

  getActions(currentPage){
    if(currentPage==="productPage"){
      return ['filter-active']
    }
    if(currentPage==="detailedSearchPage"){
      return ['search-active', 'filter-active']
    }
    if(currentPage==="configuratorPage"){
      return [configuratorActions.ASSIGN,
        configuratorActions.RESET,
        configuratorActions.REMOVE,
        configuratorActions.LOADED,
        configuratorActions.FROMTEMPLATE,
        superCodeActions.CREATE,
        'search-active',
        'filter-active',
        flagActions.ADDING
      ]
    }
    if(currentPage==="modelConfiguratorPage"){
      return Object.keys( configuratorActions ).map( key => configuratorActions[key] );
    }
    if(currentPage==="accessoryConfiguratorPage"){
      return [configuratorActions.ASSIGN, configuratorActions.RESET, configuratorActions.REMOVE, configuratorActions.LOADED]
    }
    if(currentPage==="categoriesPage"){
      return ['filter-active']
    }
    if(currentPage==="cartPage"){
      return ['filter-active',importActions.VALIDATE, superCodeActions.CREATE]
    }
    return []
  }

  toggle = () => {
    const { userMenuActive } = this.state;
   this.setState( { userMenuActive: !userMenuActive } );
  }

  render() {
    const { siteSettings, user } = this.props;
    
    let copyrightData;
    const year = new Date().getFullYear();
    let copyrightArr = translate( "© Copyright 2018 ABB" ).split(' ');
    copyrightArr[2] = year;
    copyrightData = copyrightArr.join(' ');

    const contactUsCountries = ["SE"]
    const supportUrl =  "https://forms.abb.com/form-37634/CS-EConfigure";

    let actions = this.getActions(this.props.currentPage.currentPage);
    return(
      <BusyContainer className="site-footer-container" actions={actions}>
              <Box sx={{height:"100%", width:"100%", display:'flex', flexDirection:{md:"row", xs:"column"}, alignItems:"center", justifyContent:{md:"center", xs:"start"},
              gap:"8px", padding:{md:"32px 16px", xs:"16px"} }}>
                <div className='site-footer'>
                <Box height="100%" width="100%" sx={{display:{xl:"flex", md:"flex", sm:"none", xs:"none"}, justifyContent:"center", alignItems:"center"}}>
                <span className='grey'>{ translate( "© ABB eConfigure" ) }  </span>

              <Box margin="24px" sx={{width:"0px", height:"16px", alignSelf:{md:"center", xs:"baseLine"}, display:{xl:"flex", md:"flex", sm:"none", xs:"none"}}} border="1px solid #BABABA"></Box>
              
              <span>
                                <a className='black' target="_blank" href={ siteSettings.privacyPolicy }>{ translate( "Privacy Policy" ) }</a>
                              </span>
          
              <Box margin="24px" sx={{width:"0px", height:"16px",display:{xl:"flex", md:"flex", sm:"none", xs:"none"}, alignSelf:{md:"center", xs:"baseLine"}}} border="1px solid #BABABA"></Box>
              
              <span>
                              <span className="black clickable" onClick={ this.openTermsOfUse }>{ translate( 'Terms of Use' ) }</span>
                              </span>

              <Box margin="24px" sx={{width:"0px", height:"16px", display:{xl:"flex", md:"flex", sm:"none", xs:"none"}, alignSelf:{md:"center", xs:"baseLine"}}} border="1px solid #BABABA"></Box>

              <span>
                              <a className='black' target="_blank" href={ siteSettings.providerInfo } >{ translate( "Provider information" ) }</a>
                              </span>
                              { siteSettings.showICPNumber &&
                              <> <Box margin="24px" sx={{width:"0px", height:"16px", display:{xl:"flex", md:"flex", sm:"none", xs:"none"}, alignSelf:{md:"center", xs:"baseLine"}}} border="1px solid #BABABA"></Box>
                       <a className='black' target="_blank" href={ siteSettings.icpNumberUrl } >{ translate( "ICP number" ) }</a></>
                      }
      <Box sx={{flexGrow:1, display:{xl:"flex", md:"flex", sm:"none", xs:"none"}}} ></Box>
      
      <span className='grey'>{ `${translate("Version")}: 1.0.1` }  </span>

      {contactUsCountries.includes(user.country)&&<><Box margin="24px" sx={{width:"0px", height:"16px", alignSelf:{md:"center", xs:"baseLine"}, display:{xl:"flex", md:"flex", sm:"none", xs:"none"}}} border="1px solid #BABABA"></Box>
        <span className='grey'>{ translate( "need help" ) }  </span>
        <span className='grey' style={{marginLeft:"8px"}}>
        { user && siteSettings.showRequestButton ?  <RequestSupport/> :
            <a className='black' target="_blank" href={ supportUrl } >{ translate( "contact us" ) }</a>
            }
        </span></>}
                </Box>
        <Box width="100%" sx={{display:{xl:"none", md:"none", sm:"flex", xs:"flex"}, flexDirection:"column", gap:"16px"}}> 
        {
          siteSettings.showUserMenu && !siteSettings.isIntegrated && <div tabIndex="-1" className={ classNames('user-menu-panel', 'active')  } 
          //  onBlur={ this.hideUserMenu }
            >
            <div className='settings' onClick={ this.toggle}>
              <Box component="img" sx={{width:"16px", height:"16px", background:"transparent",borderRadius:"56px", padding:{md:"12px", xs:"0px"}}} src={ SettingsIconNew }/>
              <span className="text">{translate("Settings")}</span>
            </div>
            
            <Dialog className='Profile' hideBackdrop={true} open={this.state.userMenuActive} onClose={this.toggle} PaperProps={{sx:{
              position: "absolute",
              top: "auto",
              width:"max-content",
              height:"max-content",
              margin:"0px",
              overflow:"unset",
            }}}>
              <UserMenu siteFooter/>
            </Dialog>
            </div>  
          } 
        <Box sx={{height:"14px", width:"100%", display:{xl:"none", md:"none", sm:"flex", xs:"flex"}, flexDirection:"row", alignItems:"center", justifyContent:"start",alignSelf:"baseLine"}}>
                <span>
                        <a className='black' target="_blank" href={ siteSettings.privacyPolicy }>{ translate( "Privacy Policy" ) }</a>
                      </span>
                      <Box border="1px solid #BABABA" sx={{width:"0px", height:"16px",mx:"16px", display:{xl:"none", md:"none", sm:"flex", xs:"flex"}}} ></Box>
                      <span
                      >
                        <span className="black clickable" onClick={ this.openTermsOfUse }>{ translate( 'Terms of Use' ) }</span>
                      </span>
                      {(contactUsCountries.includes(user.country))&&<> <Box border="1px solid #BABABA" sx={{width:"0px", height:"16px",mx:"16px", display:{xl:"none", md:"none", sm:"flex", xs:"flex"}}} ></Box>
                      <span>
                      { user && siteSettings.showRequestButton ?  <RequestSupport/> :
                          <a className='black' target="_blank" href={ supportUrl } >{ translate( "contact us" ) }</a>
                          }
                      </span></>}
                      {(siteSettings.configuration && siteSettings.configuration.navigationLinks.filter(link => link.translationKey === "Support" && link.isEnabled).length > 0)&&<> <Box border="1px solid #BABABA" sx={{width:"0px", height:"16px",mx:"16px", display:{xl:"none", md:"none", sm:"flex", xs:"flex"}}} ></Box>
                      <span>
                      { <Link className='black' to="/support">{translate("Support")}</Link>}
                      </span></>}
                     
              </Box>
              <Box sx={{display:"flex"}}>
              <span>
                              <a className='black' target="_blank" href={ siteSettings.providerInfo } >{ translate( "Provider information" ) }</a>
                              </span>
                              { siteSettings.showICPNumber &&
                              <> <Box border="1px solid #BABABA" sx={{width:"0px", height:"16px",mx:"16px", display:{xl:"none", md:"none", sm:"flex", xs:"flex"}}} ></Box>
                     <span>  <a className='black' target="_blank" href={ siteSettings.icpNumberUrl } >{ translate( "ICP number" ) }</a></span></>
                      } 
                      </Box>
              <Box width="100%" height="15px" sx={{display:{xl:"none", md:"none", sm:"flex", xs:"flex"}, flexDirection:"row",
                                justifyContent:"start"}}>
              <span className='grey'>{ translate( "© ABB eConfigure" ) } </span>
              <Box sx={{flexGrow:1, display:{md:"nonde", xs:"flex"}}}>

              </Box>
              <span className='grey'>{`${translate("Version")}: 1.0.1` }</span>        
              </Box>
            </Box>
                </div>
            <Dialog open={this.state.showTC} onClose={this.closeTermsOfUse} 
              PaperProps={{sx:{
                overflow:"hidden",
                alignSelf:"start",
                top:{md:200, xs:145},
                margin:"20px",
              }}}
              >
                <IconButton sx={{width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, position: "absolute",
                    right: "11px",
                    top: "12px"}} onClick={this.closeTermsOfUse}>
                  <Box component="img" src={closePopup} sx={{width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}}}></Box>
                </IconButton>
                <TermsOfUseWindow close={this.closeTermsOfUse}></TermsOfUseWindow>
            </Dialog>         
      </Box>
      </BusyContainer>

  );
  }
}

SiteFooterComponent.propTypes = {
  siteSettings: PropTypes.shape( {
    isIntegrated: PropTypes.bool.isRequired,
    providerInfo: PropTypes.string.isRequired,
    privacyPolicy: PropTypes.string.isRequired,
  } )
};

export const SiteFooter = connect( combineStates(siteSettingsState,currentPageState,identityState), popupDispatcher )( SiteFooterComponent );